// extracted by mini-css-extract-plugin
export default {"AdminTopics":"admin-topics_AdminTopics__6pSl4","SearchBlock":"admin-topics_SearchBlock__z-59e"};